module.exports = __webpack_public_path__ + "static/media/x.bb8a528f.svg";